import * as React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"

const minDigits = 0
const maxDigits = 10
export const defaultDigits = 3

export const decimalDigitsControlId = "decimalDigitsControlGroup"

/**
 * A controlled component for editing how many digits should be displayed after the decimal point.
 */
const DecimalDigits = (props: {
  value: number
  disabled?: boolean
  onChange?: (id: string, digits: number) => void
  onBlur?: () => void
}) => {
  const safeValue = clampDecimalDigits(props.value)

  const onDigitsInputChange = (e: any) => {
    e.persist()
    const newDigits = clampDecimalDigits(+e.target.value)
    if (props.onChange) {
      props.onChange(decimalDigitsControlId, newDigits)
    }
  }

  return (
    <Form.Group
      as={Row}
      controlId={decimalDigitsControlId}
      className="align-items-baseline"
    >
      <Form.Label column={true} md="3">
        Decimal digits
      </Form.Label>
      <Col md="2">
        <Form.Control
          type="number"
          value={safeValue}
          min={minDigits}
          max={maxDigits}
          step={1}
          disabled={props.disabled}
          onChange={onDigitsInputChange}
          onBlur={props.onBlur}
        />
      </Col>
      <Col md="7">
        <Form.Control
          type="range"
          custom={true}
          min={minDigits}
          max={maxDigits}
          step={1}
          value={safeValue}
          disabled={props.disabled}
          onChange={onDigitsInputChange}
          onBlur={props.onBlur}
        />
        <Form.Text>
          Number of digits to display after the decimal point. Does not affect
          stored value precision.
          <br />
          <i>
            Preview: 123{(safeValue > 0 ? "." : "") + "0".repeat(safeValue)}
          </i>
        </Form.Text>
      </Col>
    </Form.Group>
  )
}

const clampDecimalDigits = (digits: number) =>
  Math.min(Math.max(digits, minDigits), maxDigits)

export default DecimalDigits
